var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value === true)?_c('v-icon',{attrs:{"color":"d-green"}},[_vm._v(" mdi-check ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }